module.exports = __webpack_public_path__ + "static/img/logo.b137d679.png";